import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import type { DisplayPost } from "./blogTypes";

/**
 * Highlights either the post explicitly flagged `featured` in the static fallback data, or
 * (when using the real Ghost feed, which has no such flag) simply the first post returned --
 * the API already returns newest-first, so that's a presentational choice, not fabricated data.
 */
const BlogsFeatured: React.FC<{ post: DisplayPost }> = ({ post }) => {
  const history = useHistory();

  return (
    <section className="bp-featured">
      <div
        className="bp-featured__card"
        onClick={() => history.push(`/blogs/${post.slug}`)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") history.push(`/blogs/${post.slug}`);
        }}
      >
        <div className="bp-featured__media">
          <img src={post.cover} alt={post.title} />
          <div className="bp-featured__media-scrim" />
          <span className="bp-featured__badge">Featured</span>
          <span className="bp-featured__stamp">© eZy</span>
        </div>
        <div className="bp-featured__body">
          <div className="bp-featured__date">
            {post.date ? moment(post.date).format("MMMM D, YYYY") : ""}
            {post.readMin ? ` · ${post.readMin} min read` : ""}
          </div>
          <h2 className="bp-featured__title">{post.title}</h2>
          <p className="bp-featured__excerpt">{post.excerpt}</p>
          {post.author && (
            <div className="bp-featured__author">
              {post.initials && <span className="bp-featured__avatar">{post.initials}</span>}
              <span>{post.author}</span>
            </div>
          )}
          <span className="bp-featured__read">
            Read article <span aria-hidden="true">→</span>
          </span>
        </div>
      </div>
    </section>
  );
};

export default BlogsFeatured;
